/**
 * Permission ID definitions. Add a row here to introduce an ID
 * (and an override in orgPolicyOverrideRules.ts if tenant-configurable).
 * See docs/authz.md Reference.
 */
import type { UserRole } from "@models/UserRole";
import permissions from "@utils/permissions";

type PermissionDefinition = {
  defaultRoles: readonly UserRole[];
  summary: string;
};

export const PERMISSION_DEFINITIONS = {
  "catalog.archive.read": {
    defaultRoles: permissions.items,
    summary:
      "Browse the catalog of archived items. Admins always retain access.",
  },
} as const satisfies Record<string, PermissionDefinition>;

export type PermissionId = keyof typeof PERMISSION_DEFINITIONS;
